// extracted by mini-css-extract-plugin
module.exports = {"header":"list_header__1_bIn","heading":"list_heading__3_Kiq"};